import React from 'react';
import { Tabs, Row, Col } from 'antd';
import "./Styles/TabComponent.scss";
const { TabPane } = Tabs;

const sampleConfig = [
    {
        value: 'this_month',
        label: 'This Month',
        children: 'This Month',
    },
    {
        value: 'this_year',
        label: 'This Year',
        children: <div>This Year</div>,
    },
    {
        value: 'past_year',
        label: 'Past Year',
        children: <div>Past Year</div>,
    },
];
export default class extends React.Component {
    _baseClassName = "tab-component"
    constructor(props) {
        super(props);

        this.state = {
            props: this.props,
            config: this.props.config || sampleConfig,
            selectedTab: this.props.defaultActiveKey || 'this_month',
        };

        this.handleTabChange = this.handleTabChange.bind(this);
    }

    handleTabChange(selected) {
        this.setState({
            selectedTab: selected,
        });
        typeof this.props.onChange == 'function' &&
            this.props.onChange(selected);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps !== prevState.props) {
            return { props: nextProps, selectedTab: nextProps.defaultActiveKey };
        } else return null;
    }

    render() {
        return (
            <div className={`${this._baseClassName} ${this.props.className || ''}`} style={this.props.style || {}}>

                <Row >
                    <Col xs={24} sm={24} md={24} lg={32}>
                        <Tabs
                            activeKey={this.state.selectedTab}
                            // moreIcon={null}
                            tabBarExtraContent={this.props?.ExtraContent ? this.props.ExtraContent : null}
                            {...this.props}
                            onChange={this.handleTabChange}
                        >
                            {(this.state.config || []).map((tab, i) => {
                                return (
                                    tab.label ? <TabPane tab={tab.label} key={tab.value || tab.label}>
                                        <div className='tab-children'>
                                            {tab.render && typeof tab.render == "function" ? tab.render({ tab }) : tab.render}
                                        </div>
                                    </TabPane> : <></>
                                );
                            })}
                        </Tabs>
                    </Col>
                </Row>
            </div>
        );
    }
}
